(function () {

    jQuery('[data-background]').each(function () {

        const element = jQuery(this);
        const mediaQuery = window.matchMedia('(min-width: 760px)');

        const swapSource = function (mq) {
            if (mq.matches) {
                return element.css({
                    backgroundImage: `url(${element.data('background')})`,
                });
            }

            element.css({
                backgroundImage: `url(${element.data('background-mobile')})`,
            });
        };

        if (!element.data('background-mobile')) {
            return element.css({
                backgroundImage: `url(${element.data('background')})`,
            });
        }

        swapSource(mediaQuery);
        mediaQuery.addListener(swapSource);
    });

})();



// WEBPACK FOOTER //
// ./web/app/themes/giles/resources/js/components/data-background.js